import axios from 'axios';

import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { withParams } from '@telialt/utils/src/helpers';
import { TeliaSegment } from '@telialt/utils/src/segment';

import { API } from '../constants/constants';
import { ProductClassifications, ProductCompareClassification } from '../models';

export const apiGetProductClassifications = async (segment: TeliaSegment, baseProductCode: string) => {
    const site = segment === TeliaSegment.B2b ? 'teliaB2bWebsite' : 'teliaWebsite';

    const response = await axiosForHybris.get<ProductClassifications>(
        withParams(API.URL_PRODUCT_CLASSIFICATIONS, { site, baseProductCode }),
        {
            params: { fields: 'classifications' },
        },
    );

    return response.data;
};

export const apiGetProductsCompareClassifications = (segment: TeliaSegment, productCodes: string[]) => {
    return axios.get<ProductCompareClassification[]>(withParams(API.URL_COMPARE_CLASSIFICATIONS, { segment }), {
        params: { codes: productCodes.join(',') },
        baseURL: checkShouldUseMocks() ? undefined : '',
    });
};
